import { FieldConfig, FieldDataTypes, NameableInterface, NumberHash, Uuid } from '@hidat/huijs-common';
import { ResourceConfig, SearchFilterConfig } from '@hidat/huijs-resource';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';
import { SortOrder } from '@hidat/huijs-api';
import { LicensingKlasses, SegmentTypes } from './splixer-types';
import { HashViews } from './hash-views';

export const SegmentConfig: ResourceConfig = new ResourceConfig('Segment')
  .addFields(
    [
      splixerFieldConfigs.uid,
      splixerFieldConfigs.name,
      new FieldConfig('segmentType'),
      new FieldConfig('broadcastedAt', FieldDataTypes.DATETIME),
      new FieldConfig('duration', FieldDataTypes.INTEGER),
      new FieldConfig('hourInShow', FieldDataTypes.INTEGER),
      new FieldConfig('licensingKlass'),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs.intId,
    splixerFieldConfigs.channelId,
    splixerFieldConfigs.showId,
    splixerFieldConfigs.stationId,
    splixerFieldConfigs.hostId,
    splixerFieldConfigs.status,
    new FieldConfig('priority', FieldDataTypes.INTEGER),
    ...splixerSystemFields,
  ])
  .setSorts({
    name: 'name',
    status: {
      dbName: 'status',
      secondarySort: {
        dbName: 'name',
      },
    },
    broadcastedat: {
      dbName: 'broadcastedAt',
      defaultOrder: SortOrder.DESC,
    },
    createdat: 'createdAt',
  })
  .setDefaultSort('broadcastedat-');

export const SegmentIncludes = {
  host: 'host',
  show: 'show',
  program: 'program',
};

export const SegmentFilterConfig = new SearchFilterConfig(SegmentConfig, {
  only: ['showId', 'hostId', 'status', 'channelId', 'stationId']
})
  .addRangeField('broadcastedAt', FieldDataTypes.DATE);

export interface SegmentTraitsInterface {
  music_count: number;
  detailed_music_count: number; //Number of tracks that we have info for (label
  local_count?: number; //KEXP
  in_studio_count?: number; //KEXP
  request_count?: number; //KEXP
  rotation_counts?: NumberHash; //KEXP
  release_year_counts: NumberHash;
  release_decade_counts: NumberHash;
  label_counts: NumberHash;
  releases: NumberHash;
  performers: NumberHash;
  titles: NumberHash;
}

export interface PlayerSegmentInterface
  extends SplixerResourceInterface<number>, NameableInterface {
  uid: Uuid | undefined;
  segmentType: SegmentTypes | undefined;
  licensingKlass: LicensingKlasses | undefined;
  broadcastedAt: unknown | undefined;
  duration: number | undefined;
  hourInShow: number | undefined;
}

export interface SegmentInterface extends PlayerSegmentInterface {
  stationId: number | undefined;
  channelId: number | undefined;
  showId: number | undefined;
  hostId: number | undefined;
  traits: SegmentTraitsInterface | undefined;
  priority: number | undefined;
}
